import * as React from "react";

function SvgArchiveTime({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 24h24V0H0z" />
        <path
          fill="currentColor"
          d="M11 2.75a.75.75 0 01.102 1.493L11 4.25H5.5a2.25 2.25 0 00-2.245 2.096L3.25 6.5v8.249l3.632.001c.611 0 1.174.319 1.491.834l.074.133.447.895a.251.251 0 00.168.132l.056.006h4.763a.251.251 0 00.194-.091l.03-.047.447-.894c.274-.548.812-.91 1.414-.961l.152-.007 3.632-.001V13a.75.75 0 011.493-.102l.007.102v5.5a3.75 3.75 0 01-3.55 3.745l-.2.005h-12a3.75 3.75 0 01-3.745-3.55l-.005-.2v-12A3.75 3.75 0 015.3 2.755l.2-.005H11zM3.25 18.5a2.25 2.25 0 002.096 2.245l.154.005h12a2.25 2.25 0 002.245-2.096l.005-.154v-2.251l-3.632.001a.251.251 0 00-.194.091l-.03.047-.447.894c-.274.548-.812.91-1.414.961l-.152.007H9.118a1.75 1.75 0 01-1.492-.835l-.074-.133-.447-.894a.25.25 0 00-.168-.132l-.055-.006-3.632-.001V18.5zM17 1.75a5.25 5.25 0 01.004 10.5h-.01a5.32 5.32 0 01-5.244-5.239A5.254 5.254 0 0117 1.75zm0 1.5A3.75 3.75 0 0013.25 7a3.816 3.816 0 003.566 3.742l.193.009a3.752 3.752 0 003.24-5.627A3.75 3.75 0 0017 3.25zm-.107 1.916a.75.75 0 01.743.648l.007.102v1.337l1.023.624a.749.749 0 01.296.94l-.047.09a.748.748 0 01-.94.297l-.09-.047-1.383-.843a.748.748 0 01-.35-.53l-.009-.11V5.916a.75.75 0 01.75-.75z"
        />
      </g>
    </svg>
  );
}

export default SvgArchiveTime;
